module.exports = __webpack_public_path__ + "fonts/Suntowns.184a373.ttf";